import { createContext, useContext, useState, type ReactNode } from "react";
import type { UserRole } from "@shared/schema";

interface RoleContextType {
  role: UserRole;
  setRole: (role: UserRole) => void;
  currentDoctorId: string;
  currentDepartmentId: string;
}

const RoleContext = createContext<RoleContextType | undefined>(undefined);

export function RoleProvider({ children }: { children: ReactNode }) {
  const [role, setRole] = useState<UserRole>("admin");
  
  // For demo purposes, assign specific IDs for doctor/nurse/department head views
  const currentDoctorId = "doc1"; // BS. Nguyễn Văn An
  const currentDepartmentId = "d1"; // Cardiovascular Department

  return (
    <RoleContext.Provider value={{ role, setRole, currentDoctorId, currentDepartmentId }}>
      {children}
    </RoleContext.Provider>
  );
}

export function useRole() {
  const context = useContext(RoleContext);
  if (!context) {
    throw new Error("useRole must be used within a RoleProvider");
  }
  return context;
}
